import { Box, TouchableBox, AHText, SubTodoIndicator } from "arkh";
import React from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TodoCircleStatusWithResponse } from "../../TodoCategory/TodoCircleStatusWithResponse";
import { TodoEditNewMainParentIndicator_todo$key } from "./__generated__/TodoEditNewMainParentIndicator_todo.graphql";

export function TodoEditNewMainParentIndicator(props: {
  onPress: (parentId: string) => void;
  todo: TodoEditNewMainParentIndicator_todo$key;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoEditNewMainParentIndicator_todo on Todo {
        parent {
          id
          title
          subTodos {
            status
          }
          ...TodoCircleStatusWithResponse_todo
        }
      }
    `,
    props.todo
  );
  const parent = todo.parent;
  if (!parent) {
    return null;
  }
  return (
    <Box spaceBottom="medium">
      <TouchableBox
        style={{
          flexDirection: "row",
          alignItems: "center",
          borderWidth: 1,
          flex: 1,
          justifyContent: "space-between",
        }}
        onPress={() => {
          props.onPress(parent.id);
        }}
        cornerRadius="large"
        color="surface-primary"
        spaceHorizontal="medium"
        spaceVertical="medium"
        borderColor="border-primary"
      >
        <Box style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
          <TodoCircleStatusWithResponse
            todo={parent}
            disabled={true}
            onStatusUpdateNeedsAction={() => {}}
            circleSize="small"
          />
          <AHText
            spaceLeft="medium"
            type="subtitle"
            color="text-secondary"
            style={{ flex: 1 }}
            numberOfLines={1}
          >
            {parent.title}
          </AHText>
        </Box>
        <SubTodoIndicator
          statuses={parent.subTodos?.map((s) => s.status) ?? []}
        />
      </TouchableBox>
    </Box>
  );
}
